export var sk;
(function (sk) {
    sk.names = {
        AD: "Andorra",
        AE: "Spojené arabské emiráty",
        AF: "Afganistan",
        AG: "Antigua a Barbuda",
        AI: "Anguilla",
        AL: "Albánsko",
        AM: "Arménsko",
        AO: "Angola",
        AQ: "Antarktída",
        AR: "Argentína",
        AS: "Americká Samoa",
        AT: "Rakúsko",
        AU: "Austrália",
        AW: "Aruba",
        AX: "Alandy",
        AZ: "Azerbajdžan",
        BA: "Bosna a Hercegovina",
        BB: "Barbados",
        BD: "Bangladéš",
        BE: "Belgicko",
        BF: "Burkina Faso",
        BG: "Bulharsko",
        BH: "Bahrajn",
        BI: "Burundi",
        BJ: "Benin",
        BL: "Svätý Bartolomej",
        BM: "Bermudy",
        BN: "Brunej",
        BO: "Bolívia",
        BQ: "Karibské Holandsko",
        BR: "Brazília",
        BS: "Bahamy",
        BT: "Bhután",
        BV: "Bouvetov ostrov",
        BW: "Botswana",
        BY: "Bielorusko",
        BZ: "Belize",
        CA: "Kanada",
        CC: "Kokosové ostrovy",
        CD: "Konžská demokratická republika",
        CF: "Stredoafrická republika",
        CG: "Konžská republika",
        CH: "Švajčiarsko",
        CI: "Pobrežie Slonoviny",
        CK: "Cookove ostrovy",
        CL: "Čile",
        CM: "Kamerun",
        CN: "Čína",
        CO: "Kolumbia",
        CR: "Kostarika",
        CU: "Kuba",
        CV: "Kapverdy",
        CW: "Curaçao",
        CX: "Vianočný ostrov",
        CY: "Cyprus",
        CZ: "Česko",
        DE: "Nemecko",
        DJ: "Džibutsko",
        DK: "Dánsko",
        DM: "Dominika",
        DO: "Dominikánska republika",
        DZ: "Alžírsko",
        EC: "Ekvádor",
        EE: "Estónsko",
        EG: "Egypt",
        EH: "Západná Sahara",
        ER: "Eritrea",
        ES: "Španielsko",
        ET: "Etiópia",
        FI: "Fínsko",
        FJ: "Fidži",
        FK: "Falklandy",
        FM: "Mikronézia",
        FO: "Faerské ostrovy",
        FR: "Francúzsko",
        GA: "Gabon",
        GB: "Spojené kráľovstvo",
        GD: "Grenada",
        GE: "Gruzínsko",
        GF: "Francúzska Guayana",
        GG: "Guernsey",
        GH: "Ghana",
        GI: "Gibraltár",
        GL: "Grónsko",
        GM: "Gambia",
        GN: "Guinea",
        GP: "Guadeloupe",
        GQ: "Rovníková Guinea",
        GR: "Grécko",
        GS: "Južná Georgia a Južné Sandwichove ostrovy",
        GT: "Guatemala",
        GU: "Guam",
        GW: "Guinea-Bissau",
        GY: "Guayana",
        HK: "Hongkong – OAO Číny",
        HM: "Heardov ostrov a Macdonaldove ostrovy",
        HN: "Honduras",
        HR: "Chorvátsko",
        HT: "Haiti",
        HU: "Maďarsko",
        ID: "Indonézia",
        IE: "Írsko",
        IL: "Izrael",
        IM: "Ostrov Man",
        IN: "India",
        IO: "Britské indickooceánske územie",
        IQ: "Irak",
        IR: "Irán",
        IS: "Island",
        IT: "Taliansko",
        JE: "Jersey",
        JM: "Jamajka",
        JO: "Jordánsko",
        JP: "Japonsko",
        KE: "Keňa",
        KG: "Kirgizsko",
        KH: "Kambodža",
        KI: "Kiribati",
        KM: "Komory",
        KN: "Svätý Krištof a Nevis",
        KP: "Severná Kórea",
        KR: "Južná Kórea",
        KW: "Kuvajt",
        KY: "Kajmanie ostrovy",
        KZ: "Kazachstan",
        LA: "Laos",
        LB: "Libanon",
        LC: "Svätá Lucia",
        LI: "Lichtenštajnsko",
        LK: "Srí Lanka",
        LR: "Libéria",
        LS: "Lesotho",
        LT: "Litva",
        LU: "Luxembursko",
        LV: "Lotyšsko",
        LY: "Líbya",
        MA: "Maroko",
        MC: "Monako",
        MD: "Moldavsko",
        ME: "Čierna Hora",
        MF: "Svätý Martin (fr.)",
        MG: "Madagaskar",
        MH: "Marshallove ostrovy",
        MK: "Macedónsko",
        ML: "Mali",
        MM: "Mjanmarsko",
        MN: "Mongolsko",
        MO: "Macao – OAO Číny",
        MP: "Severné Mariány",
        MQ: "Martinik",
        MR: "Mauritánia",
        MS: "Montserrat",
        MT: "Malta",
        MU: "Maurícius",
        MV: "Maldivy",
        MW: "Malawi",
        MX: "Mexiko",
        MY: "Malajzia",
        MZ: "Mozambik",
        NA: "Namíbia",
        NC: "Nová Kaledónia",
        NE: "Niger",
        NF: "Norfolk",
        NG: "Nigéria",
        NI: "Nikaragua",
        NL: "Holandsko",
        NO: "Nórsko",
        NP: "Nepál",
        NR: "Nauru",
        NU: "Niue",
        NZ: "Nový Zéland",
        OM: "Omán",
        PA: "Panama",
        PE: "Peru",
        PF: "Francúzska Polynézia",
        PG: "Papua Nová Guinea",
        PH: "Filipíny",
        PK: "Pakistan",
        PL: "Poľsko",
        PM: "Saint Pierre a Miquelon",
        PN: "Pitcairnove ostrovy",
        PR: "Portoriko",
        PS: "Palestínske územia",
        PT: "Portugalsko",
        PW: "Palau",
        PY: "Paraguaj",
        QA: "Katar",
        RE: "Réunion",
        RO: "Rumunsko",
        RS: "Srbsko",
        RU: "Rusko",
        RW: "Rwanda",
        SA: "Saudská Arábia",
        SB: "Šalamúnove ostrovy",
        SC: "Seychely",
        SD: "Sudán",
        SE: "Švédsko",
        SG: "Singapur",
        SH: "Svätá Helena",
        SI: "Slovinsko",
        SJ: "Svalbard a Jan Mayen",
        SK: "Slovensko",
        SL: "Sierra Leone",
        SM: "San Maríno",
        SN: "Senegal",
        SO: "Somálsko",
        SR: "Surinam",
        SS: "Južný Sudán",
        ST: "Svätý Tomáš a Princov ostrov",
        SV: "Salvádor",
        SX: "Svätý Martin (hol.)",
        SY: "Sýria",
        SZ: "Svazijsko",
        TC: "Turks a Caicos",
        TD: "Čad",
        TF: "Francúzske južné a antarktické územia",
        TG: "Togo",
        TH: "Thajsko",
        TJ: "Tadžikistan",
        TK: "Tokelau",
        TL: "Východný Timor",
        TM: "Turkménsko",
        TN: "Tunisko",
        TO: "Tonga",
        TR: "Turecko",
        TT: "Trinidad a Tobago",
        TV: "Tuvalu",
        TW: "Taiwan",
        TZ: "Tanzánia",
        UA: "Ukrajina",
        UG: "Uganda",
        UM: "Menšie odľahlé ostrovy USA",
        US: "Spojené štáty",
        UY: "Uruguaj",
        UZ: "Uzbekistan",
        VA: "Vatikán",
        VC: "Svätý Vincent a Grenadíny",
        VE: "Venezuela",
        VG: "Britské Panenské ostrovy",
        VI: "Americké Panenské ostrovy",
        VN: "Vietnam",
        VU: "Vanuatu",
        WF: "Wallis a Futuna",
        WS: "Samoa",
        XK: "Kosovo",
        YE: "Jemen",
        YT: "Mayotte",
        ZA: "Južná Afrika",
        ZM: "Zambia",
        ZW: "Zimbabw",
    };
})(sk || (sk = {}));
//# sourceMappingURL=sk.js.map